import React, { useContext, useEffect } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { AppContext } from '@thd-nucleus/app-render';
import { TagReturnMethodContinue } from '@src/utils/analytics-tagging';
import useFetchState from '../../hooks/useFetchState';
import { RETURN_METHOD } from '../../constants/general';
import { ReturnHeaders } from '../shared/ReturnHeaders';
import { useReturnStore } from '../../stores/returnStore';
import { useFlowStore, goToStep } from '../../stores/flowStore';
import { getFeatureSwitchStatic, getWindow, isFeatureSwitchEnabled, } from '../../utils/general';
import { LegacyInStoreReturnMethod } from './LegacyInStoreReturnMethod';
import { Phase0InStoreReturnMethod } from './Phase0InStoreReturnMethod';
import ErrorBanner from '../shared/ErrorBanner';
import ReturnMethodOptions from './ReturnMethodOptions';
export var ReturnMethodStep = function () {
    var returnMethod = useReturnStore(function (state) { return state.returnMethod; });
    var orderDetailsV2 = useReturnStore(function (state) { return state.orderDetailsV2; });
    var returnFlow = useFlowStore(function (state) { return state.returnFlow; });
    var instance = useContext(AppContext).instance;
    var allowSORISPhase0 = getWindow() && isFeatureSwitchEnabled(instance, 'allowSORISPhase0');
    var allowSORIS = getWindow() && isFeatureSwitchEnabled(instance, 'allowSORIS');
    var allowOnlineOrdersPhase0 = getWindow() && isFeatureSwitchEnabled(instance, 'allowOnlineOrdersPhase0');
    var _a = useFetchState(), loading = _a.loading, error = _a.error, fetchData = _a.fetchData, isFetched = _a.isFetched;
    var isLORPEnabled = Boolean(getFeatureSwitchStatic('isLORPEnabled', true, false));
    var isLORPChosen = returnMethod === RETURN_METHOD.LORP;
    // In Store chosen analytics tagging
    useEffect(function () {
        if (returnFlow.returnMethodFinished) {
            TagReturnMethodContinue(returnMethod);
        }
    }, [returnFlow.returnMethodFinished]);
    return (React.createElement(React.Fragment, null, !returnFlow.returnMethodFinished ? (React.createElement(React.Fragment, null,
        React.createElement(ReturnHeaders, { title: "Choose your return method" }),
        error && !loading && React.createElement(ErrorBanner, null),
        React.createElement(ReturnMethodOptions, { fetchData: fetchData, isFetched: isFetched, loading: loading, error: error }))) : (React.createElement("div", { className: "sui-flex sui-flex-col" }, allowSORIS ||
        (isLORPEnabled && isLORPChosen) ||
        returnMethod === RETURN_METHOD.UPS_DROP_OFF ? (React.createElement(React.Fragment, null,
        React.createElement(ReturnHeaders, { title: "Choose your return method", isStepperFinished: true, buttonHandlerFinished: {
                buttonHandler: function () { return goToStep('ReturnMethod'); },
                buttonName: 'Edit',
            } }),
        React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" }, isLORPChosen ? (React.createElement(Typography, null, "Large Item Pickup")) : (React.createElement(Typography, null,
            returnMethod,
            " Drop-Off"))))) : (React.createElement(React.Fragment, null, allowSORISPhase0 &&
        (allowOnlineOrdersPhase0 || (orderDetailsV2 === null || orderDetailsV2 === void 0 ? void 0 : orderDetailsV2.isInStoreOrder)) ? (React.createElement(Phase0InStoreReturnMethod, null)) : (React.createElement(LegacyInStoreReturnMethod, null))))))));
};
export default ReturnMethodStep;
